import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import joinUrl from "./joinUrl";
import loadCsv from "../../Core/loadCsv";
import { IndexType } from "./Types";
import sortedIndexBy from "lodash-es/sortedIndexBy";
import sortedLastIndexBy from "lodash-es/sortedLastIndexBy";

// Minimum and maxiumum values in a numeric range

// Start and end numbers

/**
 * An index used for searching numeric values.
 *
 * It is represented as an array of [id, value] pairs sorted by the value.
 * Searching is done by performing a binary search on the array.
 */
export default class NumericIndex {
  /**
   * Constructs a NumericIndex.
   *
   * @param url    Url of the NumericIndex CSV file. This could be a relative URL.
   * @param range  The maximum and minimum value in the index.
   */
  constructor(url, range) {
    this.url = url;
    this.range = range;
    _defineProperty(this, "type", IndexType.numeric);
    _defineProperty(this, "idValuePairs", void 0);
  }

  /**
   * Load a numeric index.
   *
   * @param indexRootUrl   The URL of the index root directory
   * @param _valueHint     Ignored for NumericIndex.
   */
  async load(indexRootUrl, _valueHint) {
    if (this.idValuePairs) return;
    const indexUrl = joinUrl(indexRootUrl, this.url);
    const promise = loadCsv(indexUrl, {
      dynamicTyping: true,
      header: true
    });
    this.idValuePairs = promise;
    return promise.then(() => {});
  }

  /**
   * Search the numeric index for values between the start and end value in NumericSearchQuery.
   *
   * @param value The start and end value to be searched.
   * @return Set of IDs that matches the search value.
   */
  async search(value) {
    if (!this.idValuePairs) throw new Error("Index not loaded");
    const range = this.range;
    const idValuePairs = await this.idValuePairs;
    const startValue = value.start === undefined ? range.min : value.start;
    const endValue = value.end === undefined ? range.max : value.end;
    const startIndex = sortedIndexBy(idValuePairs, {
      dataRowId: 0,
      value: startValue
    }, entry => entry.value);
    const endIndex = sortedLastIndexBy(idValuePairs, {
      dataRowId: 0,
      value: endValue
    }, entry => entry.value);
    const matchingIds = idValuePairs.slice(startIndex, endIndex).map(_ref => {
      let {
        dataRowId
      } = _ref;
      return dataRowId;
    });
    return new Set(matchingIds);
  }
}